/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ label: NonNullable<unknown> }} Event_Style_Summary_Style_AriaInputs */



/**
* | output |
* | --- |
* | "Caption style: {label}" |
*
* @param {Event_Style_Summary_Style_AriaInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_style_summary_style_aria = /** @type {((inputs: Event_Style_Summary_Style_AriaInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Style_Summary_Style_AriaInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Style de légende : ${i?.label}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Bildunterschriftenstil: ${i?.label}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Stile didascalia: ${i?.label}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Стиль подписи: ${i?.label}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Estilo de leyenda: ${i?.label}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`标题样式：${i?.label}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`キャプションスタイル: ${i?.label}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`कैप्शन शैली: ${i?.label}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Estilo da legenda: ${i?.label}`)
	return /** @type {LocalizedString} */ (`Caption style: ${i?.label}`)
});